"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableThemeNames = exports.ThemeProvider = exports.ThemeContext = exports.ThemeName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const react_2 = require("react");
const hooks_1 = require("../hooks");
const hexToRGB_1 = require("../tools/hexToRGB");
const altacogni_1 = require("./altacogni");
const barbie_1 = require("./barbie");
const christmas_1 = require("./christmas");
const connect_1 = require("./connect");
const enterprise_1 = require("./enterprise");
const forest_1 = require("./forest");
const humly_1 = require("./humly");
const insights_1 = require("./insights");
const insightsDark_1 = require("./insightsDark");
const lifeCycle_1 = require("./lifeCycle");
const nordomatic_1 = require("./nordomatic");
const pan_1 = require("./pan");
const schneider_1 = require("./schneider");
var ThemeName;
(function (ThemeName) {
    ThemeName["lifeCycle"] = "lifeCycle";
    ThemeName["insights"] = "insights";
    ThemeName["barbie"] = "barbie";
    ThemeName["schneider"] = "schneider";
    ThemeName["connect"] = "connect";
    ThemeName["insightsDark"] = "insightsDark";
    ThemeName["enterprise"] = "enterprise";
    ThemeName["forest"] = "forest";
    ThemeName["pan"] = "pan";
    ThemeName["nordomatic"] = "nordomatic";
    ThemeName["humly"] = "humly";
    ThemeName["christmas"] = "christmas";
    ThemeName["altacogni"] = "altacogni";
})(ThemeName = exports.ThemeName || (exports.ThemeName = {}));
const Themes = {
    lifeCycle: lifeCycle_1.theme,
    forest: forest_1.theme,
    insights: insights_1.theme,
    insightsDark: insightsDark_1.theme,
    enterprise: enterprise_1.theme,
    schneider: schneider_1.theme,
    barbie: barbie_1.theme,
    pan: pan_1.theme,
    connect: connect_1.theme,
    nordomatic: nordomatic_1.nordomatic,
    humly: humly_1.theme,
    christmas: christmas_1.theme,
    altacogni: altacogni_1.theme,
};
exports.ThemeContext = react_2.createContext({ theme: lifeCycle_1.theme });
function themeFromDef(def) {
    if (!def) {
        return lifeCycle_1.theme;
    }
    if (typeof def === 'string') {
        if (def in Themes) {
            return Themes[def];
        }
        else {
            return lifeCycle_1.theme;
        }
    }
    else {
        return def;
    }
}
const ThemeProvider = ({ theme: themeDefinition = lifeCycle_1.theme, children, }) => {
    const theme = react_2.useMemo(() => {
        return themeFromDef(themeDefinition);
    }, [themeDefinition]);
    const value = react_2.useMemo(() => ({ theme }), [theme]);
    return (jsx_runtime_1.jsx(exports.ThemeContext.Provider, Object.assign({ value: value }, { children: jsx_runtime_1.jsxs(react_1.ThemeProvider, Object.assign({ theme: theme }, { children: [jsx_runtime_1.jsx(react_1.Global, { styles: globalStyles }, void 0),
                jsx_runtime_1.jsx(react_1.Global, { styles: react_1.css `
            .openlayers-dragbox {
              background: ${hexToRGB_1.hexToRGB(theme.colors.primary, 0.1)};
              border: 3px solid ${theme.colors.primary};
              border-radius: 3px;
            }
          ` }, void 0),
                jsx_runtime_1.jsx(Fonts, {}, void 0),
                jsx_runtime_1.jsx(react_1.Global, { styles: subSup }, void 0), children] }), void 0) }), void 0));
};
exports.ThemeProvider = ThemeProvider;
function Fonts() {
    const theme = hooks_1.useTheme();
    return (jsx_runtime_1.jsx(react_1.Global, { styles: [
            ...theme.fontImports.map(font => react_1.css `
              ${font}
            `),
            react_1.css `
          body {
            font-family: ${theme.fonts.body};
          }
          h1 {
            font-size: ${theme.fontSizes['3xl']};
            font-family: ${theme.fonts.heading};
            font-weight: bold;
          }
          h2 {
            font-family: ${theme.fonts.subheading};
            font-size: ${theme.fontSizes['2xl']};
            font-weight: bold;
          }
          h3 {
            font-family: ${theme.fonts.subheading};
            font-size: ${theme.fontSizes['xl']};
            font-weight: bold;
          }
          h4 {
            font-family: ${theme.fonts.subheading};
            font-size: ${theme.fontSizes['lg']};
            font-weight: bold;
          }
          h5 {
            font-family: ${theme.fonts.subheading};
            font-size: ${theme.fontSizes['lg']};
          }
          h6 {
            font-family: ${theme.fonts.subheading};
            font-size: ${theme.fontSizes['md']};
            font-weight: bold;
          }
        `,
        ] }, void 0));
}
exports.availableThemeNames = Object.keys(ThemeName).reduce((acc, val) => {
    acc[val] = Themes[val].userFriendlyName;
    return acc;
}, {});
const subSup = react_1.css `
  // https://gist.github.com/unruthless/413930

  sub,
  sup {
    /* Specified in % so that the sup/sup is the
     right size relative to the surrounding text */
    font-size: 75%;

    /* Zero out the line-height so that it doesn't
     interfere with the positioning that follows */
    line-height: 0;

    /* Where the magic happens: makes all browsers position
     the sup/sup properly, relative to the surrounding text */
    position: relative;

    /* Note that if you're using Eric Meyer's reset.css, this
     is already set and you can remove this rule */
    vertical-align: baseline;
  }

  sup {
    /* Move the superscripted text up */
    top: -0.5em;
  }

  sub {
    /* Move the subscripted text down, but only
     half as far down as the superscript moved up */
    bottom: -0.25em;
  }
`;
const resetStyles = react_1.css `
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  th {
    text-align: left;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;
const defaultStyles = react_1.css `
  * {
    box-sizing: border-box;
  }

  #root {
    height: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    overscroll-behavior-y: contain;
    height: 100%;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 300;
  }

  a {
    font-weight: bold;
    color: inherit;
    text-decoration: none;
  }

  p {
    font-weight: 300;
    padding: 0.1rem 0 0.7rem;
    margin: 0 0 0 !important;
    font-weight: 300;
  }

  li {
    font-weight: 300;
  }

  hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  video  {
    max-width: 100%;
    max-height: 400px;
    margin: 0 auto;
  }

  img {
    max-width: none;
  }

  @media screen and (max-width: 768px) {
    html {
      font-size: 15px;
    }
  }

  html {
    height: 100%;
  }

  code {
    font-family: 'Source Code Pro', monospace;
  }
`;
const globalStyles = [resetStyles, defaultStyles];
//# sourceMappingURL=index.js.map